import { Card, CardContent } from '@/components/ui/card';
import { CardHeaderSkeleton } from '@/components/ui/skeletons';
import { Tooltip } from '@/components/ui/tooltip';
import { TooltipProvider, TooltipTrigger, TooltipContent } from '@radix-ui/react-tooltip';
import { Info } from 'lucide-react';

export function MetricCard({
  title,
  value,
  description,
  isLoading,
  tooltip,
  icon
}: {
  title: string;
  value: string;
  description: string;
  isLoading: boolean;
  tooltip?: React.ReactNode;
  icon?: React.ReactNode;
}) {
  return (
    <Card className="bg-card rounded-lg border w-[390px] h-[140px]">
      <CardContent className="h-full flex items-center">
        {isLoading ? (
          <div className="w-full pt-6">
            <CardHeaderSkeleton />
          </div>
        ) : (
          <div className="flex flex-col w-full">
            <div className="flex items-center font-medium text-muted-foreground whitespace-nowrap">
              <span className="font-mono text-xs font-medium uppercase tracking-[.08em]">
                {title}
              </span>
              {icon && <span className="ml-auto">{icon}</span>}
            </div>
            <div className="text-4xl font-semibold text-foreground whitespace-nowrap">{value}</div>
            <div className="text-sm text-muted-foreground flex items-center gap-1">
              {description}
              {tooltip && (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Info className="h-3.5 w-3.5 text-muted-foreground cursor-pointer" />
                    </TooltipTrigger>
                    <TooltipContent>{tooltip}</TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
